export enum EditStatus {
    Idle,
    Saving,
    Error,
    Saved
}